module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_10.f7c892d6.png";